import React from 'react';

const NoMatch = () => {
  return( 
  <>
  <h1>Error </h1>
  <h3> Page not found</h3>
  </>
  );
};

export default NoMatch;
